import React from "react";
import { Github, Facebook, Linkedin, Twitter, ExternalLink } from "lucide-react";
import "../styles/theme.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer glass">
      <div className="footer-content">
        {/* Brand/Identity Section */}
        <div className="footer-section brand-info">
          <h3 className="footer-logo">Israel Mrakpor</h3>
          <p>
            Full-Stack Creative Developer based in <b>Nigeria</b>. 
            Bridging the gap between code and design.
          </p>
          
        </div>

        {/* Links Section */}
        <div className="footer-section links-info">
          <h4>Live Platforms</h4>
          <ul className="footer-links-list">
            <li>
              <a href="https://israelcreativehub.com.ng" target="_blank" rel="noreferrer">
                Israel Creative Hub <ExternalLink size={14} />
              </a>
            </li>
            <li>
              <a href="https://mail-temp.web.app" target="_blank" rel="noreferrer">
                TempDrop <ExternalLink size={14} />
              </a>
            </li>
          </ul>
        </div>

        {/* Socials Section */}
        <div className="footer-section socials-info">
          <h4>Connect</h4>
          <div className="footer-social-grid">
            <a href="https://github.com/Dktam18" target="_blank" rel="noreferrer" className="footer-social-btn">
              <Github size={20} />
            </a>
            <a href="https://facebook.com/profile.php?id=61578464693137" target="_blank" rel="noreferrer" className="footer-social-btn">
              <Facebook size={20} />
            </a>
            <a href="https://linkedin.com/in/israelmrakpor-b40a21363/" target="_blank" rel="noreferrer" className="footer-social-btn">
              <Linkedin size={20} />
            </a>
            <a href="https://x.com/IsraelMrakpor" target="_blank" rel="noreferrer" className="footer-social-btn">
              <Twitter size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-divider"></div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Israel Mrakpor. All Rights Reserved.</p>

      </div>
    </footer>
  );
}